/* eslint-disable */

import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';

Swiper.use([Autoplay, Navigation, Pagination]);
(function() {
  function setActiveArticle(swiper) {
    let featuredArticlesList = null;

    if (swiper.el.parentNode.previousElementSibling?.classList?.contains('articles-column')) {
      featuredArticlesList = swiper.el.parentNode.previousElementSibling.querySelector('.wp-block-app-featured-articles-list');
    }

    if (swiper.el.parentNode.nextElementSibling?.classList?.contains('articles-column')) {
      featuredArticlesList = swiper.el.parentNode.nextElementSibling.querySelector('.wp-block-app-featured-articles-list');
    }

    if (!featuredArticlesList) {
      return;
    }

    const currentActiveArticle = featuredArticlesList.querySelector('li.active');

    if (currentActiveArticle) {
      currentActiveArticle.classList.remove('active');
    }

    const nextActiveArticleId = swiper.slides[swiper.activeIndex]?.getAttribute('data-article-id');
    const nextActiveArticle = featuredArticlesList.querySelector(`li[data-article-id="${nextActiveArticleId}"]`);

    if (nextActiveArticle) {
      nextActiveArticle.classList.add('active');
    }
  }

  // eslint-disable-next-line no-unused-vars
  const articlesGallerySwiper = new Swiper('.articles-gallery-swiper', {
    slidesPerView: 1,
    slidesPerGroup: 1,
    responsive: true,
    observer: true,
    autoplay: {
      delay: 3500,
      disableOnInteraction: false,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      type: 'bullets',
    },
    on: {
      init: setActiveArticle,
      slideChange: setActiveArticle,
    },
  });

  function switchToHoveredArticle(e) {
    const articleId = e.currentTarget.getAttribute('data-article-id');
    const articlesGalleryBlock = document.querySelector(
      '.wp-block-app-featured-articles .wp-block-app-featured-articles-gallery',
    );
    const articleSlide = articlesGalleryBlock?.querySelector(`li.swiper-slide[data-article-id="${articleId}"]`);

    if (articleSlide) {
      const articleSlideIndex = articleSlide.getAttribute('data-index');
      articlesGallerySwiper.slideTo(Number(articleSlideIndex));
    }
  }

  const featuredArticlesListBlock = document.querySelector(
    '.wp-block-app-featured-articles .wp-block-app-featured-articles-list',
  );

  if (featuredArticlesListBlock) {
    const articles = featuredArticlesListBlock.querySelectorAll('li');

    for (const article of articles) {
      article.addEventListener('mouseover', switchToHoveredArticle);
    }
  }

  const featuredArticlesSwiper = () => {
    const swiper = new Swiper(".wp-block-app-featured-articles-list", {
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 35,
      responsive: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });

    return swiper;
  };

  featuredArticlesSwiper();
})();
